import type { AxiosInstance } from 'axios';
import { stringify } from 'query-string';
import { PERSONNEL_API_ENDPOINTS } from './endpoints';
import { StoreListSuccessResponse, ApiStoreListRequest, StoreHttpClientType } from './types/index';

export const createStoreHttpClient = (props: { httpClient: AxiosInstance }): StoreHttpClientType => {
  const { httpClient } = props;
  const getStores = async (request: ApiStoreListRequest): Promise<StoreListSuccessResponse> => {
    const queryParams: Record<string, string> = {};
    if (request.organizationUuid) queryParams.organization_uuid = request.organizationUuid;
    if (request.storeUuid) queryParams.store_uuid = request.storeUuid;

    const response = await httpClient.get<StoreListSuccessResponse>(
      `${PERSONNEL_API_ENDPOINTS.STORES.LIST}?isDraft=false&${stringify(queryParams)}`,
    );
    return response.data;
  };

  return {
    getStores,
  };
};
